import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { View } from 'foundations-components/components/View';
import { hasCategoryBasedPropertySelect } from '../../permissions/gates';
import { useContext, useEffect, useState } from 'react';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import EditorConditionSelect from './EditorConditionSelect';
import FormattedMessage from 'I18n/components/FormattedMessage';
import EditorConditionWrapper from './EditorConditionWrapper';
import EditorEmptyStateMessage from './EditorEmptyStateMessage';
import DataExplorer from '../dataExplorer/DataExplorer';
import { jsx as _jsx } from "react/jsx-runtime";
function SegmentationFiltersEditor() {
  const {
    dispatch,
    draftCondition,
    fetchMore,
    hasLoadedEditorData,
    isFieldSelectMode,
    requiredIdsByAssetFamily,
    getIsUngated,
    hasScope,
    viewerClonedGroupIndex,
    isInEditMode,
    props: {
      baseFilterFamily,
      strategy,
      useOnePanel
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const [showLoadingSpinner, setShowLoadingSpinner] = useState(!hasLoadedEditorData);
  useEffect(() => {
    if (!hasLoadedEditorData && requiredIdsByAssetFamily) {
      const onMountProps = {
        baseFilterFamily,
        fetchMore,
        getIsUngated,
        hasScope
      };
      setShowLoadingSpinner(true);
      strategy.onEditorMount(onMountProps, requiredIdsByAssetFamily).then(() => {
        dispatch({
          type: 'hasLoadedEditorData',
          payload: true
        });
      }).finally(() => {
        setShowLoadingSpinner(false);
      });
    }
  }, [baseFilterFamily, dispatch, fetchMore, getIsUngated, hasLoadedEditorData, hasScope, requiredIdsByAssetFamily, strategy]);
  useEffect(() => {
    if (viewerClonedGroupIndex !== undefined) {
      setShowLoadingSpinner(true);
      setTimeout(() => setShowLoadingSpinner(false), 500);
    }
  }, [viewerClonedGroupIndex]);
  if (showLoadingSpinner) {
    return /*#__PURE__*/_jsx(View, {
      backgroundColor: "fill-field-default",
      blockSize: "100%",
      inlineSize: "400px",
      children: /*#__PURE__*/_jsx(LoadingSpinner, {
        grow: true,
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "newCustomerDataFilters.general.loadingFilters"
        }),
        showLabel: true,
        size: "small"
      })
    });
  }
  if (isFieldSelectMode) {
    if (useOnePanel) {
      if (hasCategoryBasedPropertySelect()) {
        return /*#__PURE__*/_jsx(DataExplorer, {});
      }
      // https://hubspot.slack.com/archives/CA3JB5WLT/p1738861626946659
      // We can restrict the width since this will always render in a popover
      return /*#__PURE__*/_jsx(View, {
        blockSize: "100%",
        inlineSize: "400px",
        children: /*#__PURE__*/_jsx(EditorConditionSelect, {})
      });
    }

    // https://hubspot.slack.com/archives/C014EF9F8NB/p1739216713846309
    // We cannot restrict the width since it could be controlled by the app via `editorDOMContainer`
    return /*#__PURE__*/_jsx(EditorConditionSelect, {});
  }
  if (draftCondition !== null && draftCondition !== void 0 && draftCondition.conditionPath && draftCondition !== null && draftCondition !== void 0 && draftCondition.filterFamily) {
    return /*#__PURE__*/_jsx(EditorConditionWrapper, {
      conditionPath: draftCondition.conditionPath,
      filterFamily: draftCondition.filterFamily,
      inputUse: useOnePanel ? 'on-dark' : undefined
    });
  }
  if (isInEditMode) {
    return /*#__PURE__*/_jsx(EditorEmptyStateMessage, {});
  }
  return null;
}
export default SegmentationFiltersEditor;